import axios from 'axios';
// import Cookies from 'js-cookie';
import { getAuthHeader } from './userInfo-actions';

// const jwtCookie = Cookies.get(
//   `${process.env.REACT_APP_API_COOKIE_CONSTANT}`
// );

export const getStep = async origin => {
  let step = await axios.get(
    `${process.env.REACT_APP_API_PATH_PREREGISTER}/campus/register/stepper`,
    {
      params: { campus: 1, origin },
      headers: getAuthHeader()
    }
  );
  if (step.data.userStep) {
    return step.data.userStep;
  }
  return false;
};

export const setStep = async (step, dataToSave) => {
  const stepData = await axios.post(
    `${process.env.REACT_APP_API_PATH_PREREGISTER}/campus/register/stepper`,
    {
      step,
      dataToSave
    },
    { headers: getAuthHeader() }
  );
  if (stepData.data) {
    return true;
  }
  return false;
};

export const getMunicipalities = async stateId => {
  let municipalities = await axios.get(
    `${process.env.REACT_APP_API_PATH_PREREGISTER}/campus/register/municipality`,
    {
      params: { stateId },
      headers: getAuthHeader()
    }
  );
  if (municipalities.data.municipality) {
    return municipalities.data.municipality;
  }
  return false;
};

export const getCampus = async () => {
  let campus = await axios.get(
    `${process.env.REACT_APP_API_PATH_PREREGISTER}/campus/register/campus`,
    {
      params: {},
      headers: getAuthHeader()
    }
  );
  if (campus.data.campus) {
    return campus.data.campus;
  }
  return false;
};

export const getNewStep = async () => {
  const request = await axios.get(
    `${process.env.REACT_APP_API_PATH_UDC_PAYMENT}/campus/preregister/init`,
    {
      headers: getAuthHeader(),
      params: {
        campus: 1
      }
    }
  );
  return request.data.data;
};

export const getPaymentPlans = async idProgram => {
  const request = await axios.get(
    `${process.env.REACT_APP_API_PATH_UDC_PAYMENT}/campus/plans`,
    {
      headers: getAuthHeader(),
      params: {
        idProgram
      }
    }
  );
  return request.data.availablePlans;
};

export const sendInfo = async (planId, step) => {
  const request = await axios.post(
    `${process.env.REACT_APP_API_PATH_UDC_PAYMENT}/campus/preregister
`,
    {
      planId,
      step
    },
    { headers: getAuthHeader() }
  );
  if (request.data.data) {
    return request.data.data;
  } else {
    return false;
  }
};
